<template>
  <div class="test-radio-root">
    <!-- 顶部提示 -->
    <div class="dark-txt first-line" v-if="fromPage == 'introduce'">
      <div v-if="level == 'hskk1' || level == 'hskk2' || level == 'hskk3'">
        {{ $t('dialogue_listening_hskk') }}
      </div>
      <div v-else>
        {{ $t('dialogue_listening') }}
      </div>
    </div>
    <div class="dark-txt first-line" v-else-if="fromPage == 'examination'">
      {{ $t('dialogue_speaking') }}
    </div>

    <!-- 选择扬声器select -->
    <div class="raido-select-con">
      <span class="dark-txt">{{ $t('choose_speaker') }}:</span>
      <el-select
        v-model="currentAudioOutput"
        placeholder=""
        size="small"
        @change="changeAudio($event, 'speaker')"
        class="select-item"
      >
        <el-option
          v-for="item in audioOutputList"
          :key="item.deviceId"
          :label="item.label"
          :value="item.deviceId"
        >
        </el-option>
      </el-select>
    </div>
    <!-- 扬声器声波 -->
    <div class="play-wave-con">
      <div class="play-icon-con">
        <img v-if="isPlaying" @click="pausePlayer" src="@/assets/images/btn-pause.png" />
        <img v-else @click="playPlayer" src="@/assets/images/btn-play.png" />
      </div>
      <em
        class="vm"
        v-for="(wave, waveIndex) in wavForm"
        :key="waveIndex"
        :style="'height:' + wave + 'px'"
      ></em>
    </div>
    <!-- 选择麦克风 -->
    <div class="speaker-con" v-if="functionType == 'microphone'">
      <div class="raido-select-con">
        <span class="dark-txt">{{ $t('choose_microphone') }}:</span>
        <el-select
          v-model="currentAudioInput"
          placeholder=""
          size="small"
          @change="changeAudio($event, 'microphone')"
          class="select-item"
        >
          <el-option
            v-for="item in audioInputList"
            :key="item.deviceId"
            :label="item.label"
            :value="item.deviceId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="speaker-content-con">
        <Recorder
          @recordEnd="recordEnd"
          :time="recordDuration"
          :isExamMode="true"
          :manualRecord="true"
        ></Recorder>
      </div>
    </div>
    <div class="intro-msg" v-if="fromPage == 'introduce'">
      <ol v-if="level == 'hskk1' || level == 'hskk2' || level == 'hskk3'">
        <li>{{ $t('dialogue_intro_msg_first_hskk') }}</li>
        <li>{{ $t('dialogue_intro_msg_second_hskk') }}</li>
      </ol>
      <ol v-else>
        <li>{{ $t('dialogue_intro_msg_first') }}</li>
        <li>{{ $t('dialogue_intro_msg_second') }}</li>
        <li>{{ $t('dialogue_intro_msg_third', { duration: listenReviewDuration }) }}</li>
      </ol>
    </div>
    <button class="btn-yellow btn-submit" :class="{ disabled: isDisabled }" @click="skip">
      {{ $t('continue') }}
    </button>
    <p class="questions-wrap" v-if="showConcatUs">
      {{ $t('dialogue_intro_question') }}
      <b class="contact-us" @click="contactUs">{{ $t('feedback') }}</b>
    </p>
  </div>
</template>

<script>
import Recorder from '@/components/ui/recorder/index'
import { mapState } from 'vuex'
export default {
  props: {
    listenReviewDuration: {
      type: Number || String,
      default: '',
    },
    showConcatUs: {
      type: Boolean,
      default: true,
    },
    testmp3: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    functionType: {
      type: String,
      default: 'speaker', // speaker||microphone
    },
    level: {
      type: String,
      default: '', // speaker||microphone
    },
    fromPage: {
      type: String,
      default: 'introduce',
    },
  },
  data() {
    return {
      // 定时器id
      randomIntervalObj: null,
      // 初始化波形图点数组
      wavForm: [],
      // 是否正在播放
      isPlaying: false,
      // 当前的扬声器id
      currentAudioOutput: '',
      // 当前麦克风的id
      currentAudioInput: '',
      // 扬声器列表
      audioOutputList: [],
      // 麦克风列表
      audioInputList: [],
      recordDuration: 20,
    }
  },
  computed: {
    ...mapState({
      inputDeviceId: (state) => state.simulation.inputDeviceId,
    }),
  },
  methods: {
    skip() {
      this.$player.stop()
      clearInterval(this.randomIntervalObj)
      this.$emit('skip')
    },
    contactUs() {
      this.$emit('contactUs')
    },
    // 随机音频波纹长度
    randomList() {
      const that = this
      this.randomIntervalObj = setInterval(() => {
        that.wavForm = []
        for (let i = 0; i < 114; i++) {
          that.wavForm.push(parseInt(Math.random() * 80))
        }
      }, 100)
    },
    pausePlayer() {
      this.$player.sound.pause()
      this.isPlaying = false
      clearInterval(this.randomIntervalObj)
      this.wavForm = []
      for (let i = 0; i < 114; i++) {
        this.wavForm.push(1)
      }
    },
    playPlayer() {
      this.$player.sound.play()
      this.isPlaying = true
      this.randomList()
    },
    getDevices() {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            // 请求权限成功后，列举设备
            return navigator.mediaDevices.enumerateDevices()
          })
          .then((devices) => {
            devices.forEach((device) => {
              console.log(device.kind + ': ' + device.label + ' id = ' + device.deviceId)
            })
            console.log('devices', devices)
            this.audioInputList = devices.filter((device) => device.kind === 'audioinput')
            this.audioOutputList = devices.filter((device) => device.kind === 'audiooutput')
            this.currentAudioOutput = this.audioOutputList[0].deviceId
            this.currentAudioInput = this.inputDeviceId || this.audioInputList[0].deviceId
            resolve('success')
          })
          .catch((err) => {
            reject(err.name + ': ' + err.message)
            console.error(err.name + ': ' + err.message)
          })
      })
    },

    async changeAudio(deviceId, type) {
      this.audioElement = this.$player?.sound?._sounds[0]._node // 获取音频节点
      console.log('audioElement::>>', this.audioElement)
      try {
        console.log('switchDevice::>>', deviceId, '*****', type)
        if (type === 'microphone') {
          this.$store.commit('SET_INPUT_DEVICEID', deviceId)
        } else if (type === 'speaker') {
          if (this.audioElement.setSinkId) {
            try {
              await this.audioElement.setSinkId(deviceId)
            } catch (error) {
              this.$message.error(this.$t('setSinkId error:') + error)
              console.error('setSinkId error:', error)
            }
          } else {
            this.$message.error(this.$t('setSinkId_not_supported', { setSinkId: 'setSinkId' }))

            console.error('setSinkId is not supported in your browser.')
          }
        }
      } catch (error) {
        console.error('error_switch_device', error)
        this.$message.error(this.$t('error_switch_device') + ':' + error)
      }
    },

    recordEnd(res) {
      console.log('test radio recordEnd 调用了')

      let url = URL.createObjectURL(res)
      console.log(res)
      this.recordLoading = true
      const that = this
      this.pausePlayer()
      this.$player.play(url)
      this.isPlaying = true
      this.randomList()
      this.$player.onended = () => {
        that.isPlaying = false
        clearInterval(this.randomIntervalObj)
        this.wavForm = []
        for (let i = 0; i < 114; i++) {
          this.wavForm.push(1)
        }
      }

      console.log(this.$player)
    },
  },
  async mounted() {
    await this.getDevices()
    const that = this

    if (this.functionType == 'microphone') {
      this.$player.play(this.testmp3)
      this.$player.onended = () => {
        that.pausePlayer()
        that.isPlaying = false
      }
      this.$player.pause()
    } else {
      this.$player.play(this.testmp3)
      this.$player.onended = () => {
        that.pausePlayer()
        that.isPlaying = false
      }
      this.randomList()
      this.isPlaying = true
    }
  },
  beforeDestroy() {
    this.$player.stop()
    clearInterval(this.randomIntervalObj)
  },
  components: {
    Recorder,
  },
}
</script>
<style lang="scss" scoped>
.test-radio-root {
  .first-line {
    margin-bottom: 17px;
  }
  .raido-select-con {
    margin-bottom: 28px;
    .select-item {
      width: 430px;
      margin-left: 15px;
    }
  }
  .dark-txt {
    font-size: 14px;
    color: #2c2f46;
    line-height: 22px;
    word-break: break-word;
  }
  .play-wave-con {
    height: 115px;
    position: relative;
    width: 100%;
    text-align: center;
    background: #fafafc;
    padding-left: 132px;
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .vm {
      display: inline-block;
      vertical-align: middle;
      width: 2px;
      margin: 0 2px;
      background: #faae56;
    }
    .play-icon-con {
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translate(0, -50%);
      img {
        width: 85px;
        height: 85px;
        cursor: pointer;
      }
    }
  }
  .intro-msg {
    li {
      color: #696974;
      font-size: 14px;
      margin-bottom: 15px;
      line-height: 18px;
      word-break: break-word;
      &::before {
        margin: 6px 10px 3px 0;
        display: inline-block;
        content: '';
        height: 4px;
        width: 4px;
        border-radius: 100%;
        background-color: #696974;
      }
    }
  }
  .btn-submit {
    display: block;
    width: 360px;
    height: 44px;
    line-height: 44px;
    border-radius: 8px;
    margin: 25px auto 20px;
  }
  .questions-wrap {
    color: #b5b5be;
    text-align: center;
    font-size: 14px;
    b {
      cursor: pointer;
    }
  }
  button[disabled] {
    cursor: not-allowed;
    background: #dcdde3;
  }
}
.speaker-con {
  border-top: 1px dashed #e7e7ed;
  padding: 30px 0 0 0;
  margin-top: 30px;
}
.speaker-content-con {
  background: #fafafc;
  height: 196px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
